const distributorDetail = resolve => require(["@/pages/distributor/distributorDetail.vue"], resolve);
const distributor = resolve => require(["@/pages/distributor/index.vue"], resolve);



export default [
    /****************会员管理***************/
    {
        path: "/distributor",
        name: "分销商管理",
        component: distributor,
        meta: {
            keepAlive: true
        }
    },
    {
        path: "/distributor/distributordetail",
        name: "基本信息",
        component: distributorDetail,
    }
   
];
